import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AppProvider } from "./context/index";
import { toast } from "react-toastify";
import ErrorBoundary from "./components/ErrorBoundary";

function installGlobalErrorHandlers() {
  if (typeof window === "undefined") return;
  if (window.__tvmpGlobalErrorsInstalled) return;
  window.__tvmpGlobalErrorsInstalled = true;

  window.addEventListener("unhandledrejection", (event) => {
    try {
      const reason = event?.reason;
      const msg =
        reason?.response?.data?.message ||
        reason?.response?.data?.error ||
        reason?.message ||
        "Something went wrong. Please try again.";
      toast.error(String(msg));
      // Prevent CRA overlay from turning it into a full-screen crash.
      event.preventDefault?.();
    } catch {
      // noop
    }
  });

  window.addEventListener("error", (event) => {
    try {
      const msg = event?.error?.message || event?.message;
      if (msg) toast.error(String(msg));
    } catch {
      // noop
    }
  });
}

installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProvider>
      <ErrorBoundary
        onError={(err) => {
          const msg = err?.message || "Something went wrong. Please try again.";
          toast.error(String(msg));
        }}
      >
        <App />
      </ErrorBoundary>
    </AppProvider>
  </React.StrictMode>
);
